/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import '../index.css';
import './components.css';
import { Link, useLocation } from 'react-router-dom';
import { useStateValue } from '../ContextApi/StateProvider';

const DUR = 280;

const Menu = ({ onClose, onToggleTheme, themeLabel }) => {
  const [initialState, dispatch] = useStateValue();
  const authUser = initialState.authenticatedUser ? JSON.parse(initialState.authenticatedUser) : null;
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);
  const prevPath = useRef(pathname);

  // enter animation + lock background scroll
  useEffect(() => {
    const id = requestAnimationFrame(() => setOpen(true));
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      cancelAnimationFrame(id);
      document.body.style.overflow = prev;
    };
  }, []);

  // close on route change (ignore initial mount)
  useEffect(() => {
    if (prevPath.current !== pathname) {
      prevPath.current = pathname;
      handleClose();
    }
  }, [pathname]);

  const reallyClose = () => {
    dispatch({ type: 'SET_MENU_OPEN', menuOpen: false });
    onClose?.();
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(reallyClose, DUR);
  };

  return (
    <div className={`sheet-wrap ${open ? 'is-open' : ''}`} onClick={handleClose} role="dialog" aria-modal="true">
      <div className="sheet-overlay" />
      <div className="sheet-panel" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-body">
          <div className="flex items-center justify-center py-2">
            <div className="h-1.5 w-10 rounded-full bg-zinc-300 dark:bg-zinc-700" />
          </div>

          <nav className="menu-list">
            {authUser ? (
              <>
                <button onClick={onToggleTheme} className="menu-item">
                  <span className="menu-item-icon">🌓</span>
                  <span className="menu-item-text">{themeLabel}</span>
                </button>
                <Link to="/home" onClick={handleClose} className="menu-item"><span className="menu-item-icon">🏠</span><span className="menu-item-text">Home</span></Link>
                <Link to="/new-workout" onClick={handleClose} className="menu-item"><span className="menu-item-icon">➕</span><span className="menu-item-text">New Workout</span></Link>
                <Link to="/help" onClick={handleClose} className="menu-item"><span className="menu-item-icon">❓</span><span className="menu-item-text">Help</span></Link>
                <Link to="/sign-out" onClick={handleClose} className="menu-item"><span className="menu-item-icon">🚪</span><span className="menu-item-text">Sign Out</span></Link>
              </>
            ) : (
              <>
                <button onClick={onToggleTheme} className="menu-item">
                  <span className="menu-item-icon">🌓</span>
                  <span className="menu-item-text">{themeLabel}</span>
                </button>
                <Link to="/sign-in" onClick={handleClose} className="menu-item"><span className="menu-item-icon">🔐</span><span className="menu-item-text">Sign In</span></Link>
                <Link to="/sign-up" onClick={handleClose} className="menu-item"><span className="menu-item-icon">🆕</span><span className="menu-item-text">Sign Up</span></Link>
              </>
            )}
            <button onClick={handleClose} className="btn-2025 mt-2 w-full">Close</button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Menu;
